export const ProductsPageText = {
  _1: 'Products',
  _2: 'aircheckr offers the best available outside air quality information. Our unique algorithms calculate the air quality information at the level of detail you need: real-time, forecasting or statistics. aircheckr can easily be integrated into your applications through our API and widgets.'
};

export const Categories = {
  _1: {
    title: "Specifications",
    subcategories: [
      {
        key: 0,
        subtitle: 'Simple',
        text: 'Translating all these complex figures into just one value, the Air Quality Index, but you can also get the full details of all concentrations per pollutant'
      },
      {
        key: 1,
        subtitle: 'Detailed',
        text: 'For the exact location of your customers\' devices (location-based), but you can also get coarser AQ info for e.g. your city'
      },
      {
        key: 2,
        subtitle: 'Health based',
        text: 'Our air quality info is based on health statistics (and not on politically set standards). You get personalized recommendations & hints'
      },
      {
        key: 3,
        subtitle: 'Tailor-made',
        text: 'Applied to the specifics of your application. Choose the specs you exactly need for your service and your customers'
      },
      {
        key: 4,
        subtitle: 'Easy integration',
        text: 'Fluid machine to machine data transfer (API & widgets). Peanuts to integrate AQ into a wide variety of services'
      },
      {
        key: 5,
        subtitle: 'High quality',
        text: 'Intensively validated, also by external experts.'
      },
      {
        key: 6,
        subtitle: 'Fast',
        text: 'Real-time (last hour), but you can also get prognosis (next days) or historic data'
      },
      {
        key: 7,
        subtitle: 'Support',
        text: 'We help you with both our technical as thematic expertise to turn your product or demo into a success.'
      }
    ]
  },
  _2: {
    title: 'Unique algorithms',
    subcategories: [
      {
        key: 0,
        subtitle: '4 main pollutants',
        text: 'aircheckr calculates the outside air quality based on the most health impacting outside pollutants: NO2, O3, PM10 and PM2.5'
      },
      {
        key: 1,
        subtitle: 'Smart modelling',
        text: 'aircheckr developed unique, fast & on-the-fly modelling & processing techniques in order to handle the huge amount of data and speed up the calculations'
      },
      {
        key: 2,
        subtitle: 'Top input data',
        text: 'No good results without good input data. We use the best available real-time AQ measurements/models, weather data, land cover (pollution sources) & crowdsourced measurements as an input for our models'
      },
      {
        key: 3,
        subtitle: 'With a local touch',
        text: 'Every country/region is different. aircheckr always upgrades its models for each country with the best available local data.'
      },
      {
        key: 4,
        subtitle: 'Handy API',
        text: 'Our RESTful API provides the agility you expect from aircheckr: the exact information you need for your application.'
      }
    ]
  },
  _3: {
    title: 'Our portfolio',
    subcategories: [
      // {
      //   key: 0,
      //   subtitle: 'What we already offer',
      //   text: 'The aircheckr API provides near real-time air quality data for Belgium at different levels of detail.',
      //   text_2: '<strong>Flanders</strong>: real-time air quality data through our API at all levels of detail (including street level!)',
      //   text_3: '<strong>Rest of Belgium</strong>:  the aircheckr API delivers near real-time air quality data at the different levels of detail (but not yet for street level)',
      //   text_4: 'Besides the real-time capabilities, the aircheckr database contains a treasure on statistical information.'
      // },
      {
        key: 0,
        subtitle: 'Street level detail',
        text: 'Our top of the notch detailed street level product is available for complete Flanders (Belgium). It contains:',
        text_2: '<strong>Real-time hourly AQ data</strong>',
        text_3: '<strong>Yearly statistics</strong>'
      },
      {
        key: 1,
        subtitle: 'City level detail',
        text: 'The aircheckr API and widgets are providing following air quality data for all cities/municipalities, arrondissements, provinces, regions and countries in most of the countries in EU:',
        text_2: '<strong>Hourly AQ data</strong>: real-time, but also 24 hours back and the forecast for the coming 24 hours',
        text_3: '<strong>Daily AQ data</strong>: yesterday, today, tomorrow and the day after tomorrow',
        text_4: '<strong>Yearly statistics</strong>: for the moment only for Belgium'
      },
      {
        key: 2,
        subtitle: 'Working hard to extend the aircheckr portfolio',
        text: 'Follow our newsletter, to keep up to date with our new developments. If you have specific wishes that are not yet fulfilled, <a href="https://www.aircheckr.com/contact">get in touch</a> with us.'
      }
      // {
      //   key: 2,
      //   subtitle: 'Working hard to extend the aircheckr portfolio',
      //   text: 'Forecasts and different widgets are in development. The city level will soon be extended to other countries in EU. Follow our newsletter, to keep up to date with our development.'
      // }
    ]
  },
  _4: {
    title: 'Integrate',
    subcategories: [
      {
        key: 0,
        subtitle: 'Integrate our API or go for one of our widgets',
        text: 'Use the API to retrieve the aircheckr content that you need for your service. The aircheckr API allows for a fluid machine-to-machine data transfer and makes it peanuts to integrate AQ info into your own service. We are happy to <a href="https://www.aircheckr.com/contact">help you</a>.',
        text_2: 'Want to give your website visitors an attractive view on air quality? Embed one of the fancy aircheckr widgets in your browser or own website.'
      }
    ]
  }
};

export default ProductsPageText;



// WEBPACK FOOTER //
// ./src/input-text/en/products_page.js